// 用户相关校验
const userValidate = (reg, data, msg) => {
  let r = new RegExp()
  let message = ''
  switch (reg) {
    case 'email':
      r = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      message = '邮箱格式错误'
      break
    case 'password':
      r = /^[a-zA-Z]\w{5,17}$/
      message = '密码格式错误，以字母开头，长度在6~18之间，只能包含字母、数字和下划线'
      break
    case 'nickname':
      r = /^[\u4E00-\u9FA5A-Za-z0-9_]{3,10}$/
      message = '昵称只支持中英文3到15个字符'
      break
    default:
      break
  }
  message = msg || message
  return r.test(data) ? '' : message
}
export default userValidate
